import type { OrderDetail } from '@repo/api-contracts';
import type { ReactElement } from 'react';
import { orderShipmentsOf } from '@/entities/order';
import type { OrderActions } from '@/shared/lib';
import { ContentCard } from '@/shared/ui';
import { OrderDestinationBlock } from './order-destination-block';

interface OrderDestinationsProps {
  readonly order: OrderDetail;
  readonly now: string;
  readonly actions: OrderActions;
  readonly onReload: () => void;
  readonly pending?: boolean;
}

/** 배송지·송장(SUPER-86 §6-2) — 배송지 순서대로 블록. 송장은 배송지에 속한다(송장 삭제의 '마지막 송장'은 주문 전체 기준). */
export const OrderDestinations = ({
  order,
  now,
  actions,
  onReload,
  pending,
}: OrderDestinationsProps): ReactElement => {
  const ordered = [...order.destinations].sort((a, b) => a.sortOrder - b.sortOrder);
  const shipmentCount = orderShipmentsOf(order).length;
  return (
    <ContentCard title={`배송지·송장 (${ordered.length}곳)`}>
      <ul className="flex flex-col gap-4">
        {ordered.map((destination, index) => (
          <OrderDestinationBlock
            key={destination.id}
            order={order}
            destination={destination}
            index={index}
            shipmentCount={shipmentCount}
            now={now}
            actions={actions}
            onReload={onReload}
            pending={pending}
          />
        ))}
      </ul>
    </ContentCard>
  );
};
